import { createApi } from '@reduxjs/toolkit/query/react';

import { enStatusInvite, IInvite } from '@/interfaces/invite';
import { IPaginationParams, IPaginationResponse } from '@/interfaces/pagination';

import { axiosBaseQuery } from './query';

export const inviteApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'inviteApi',
  tagTypes: ['invite'],
  endpoints(build) {
    return {
      fetchAllInvitesData: build.query<IPaginationResponse<IInvite[]>, Partial<IPaginationParams>>({
        providesTags: ['invite'],
        query: params => ({
          url: '/learner/invites',
          params
        })
      }),
      checkInvite: build.query({
        query: inviteId => ({
          url: `/learner/invites/${inviteId}`
        })
      }),
      acceptInvite: build.mutation({
        invalidatesTags: ['invite'],
        query: inviteId => ({
          method: 'put',
          url: `/learner/invites/${inviteId}`,
          data: {
            status: enStatusInvite.ACCEPT
          }
        })
      }),
      acceptAllInvites: build.mutation<void, void>({
        invalidatesTags: ['invite'],
        query: () => ({
          method: 'post',
          url: '/learner/invites/all'
        })
      }),
      refuseInvite: build.mutation({
        invalidatesTags: ['invite'],
        query: hash => ({
          method: 'put',
          url: `/learner/invites/${hash}`,
          data: {
            status: enStatusInvite.REFUSED
          }
        })
      })
    };
  }
});

export const {
  useFetchAllInvitesDataQuery,
  useCheckInviteQuery,
  useAcceptInviteMutation,
  useAcceptAllInvitesMutation,
  useRefuseInviteMutation
} = inviteApi;
